import "../index.css"
import { EditorShell } from "@/editor/shell/EditorShell";

export function App() {
  return <EditorShell />;
}

export default App;
